/*
 * @FilePath: \kitchen-online-web\src\apis\offer.js
 * @Author: Yu Wang
 * @Date: 2021-07-28 14:44:12
 * @LastEditors: guten2 guorui.teng@ingka.com
 * @LastEditTime: 2022-10-26 10:47:41
 */

import request from '@/utils/request';

// 门店查询列表
export function getStoreList(data) {
  return request({
    url: `/store/list/${data}`,
    method: 'GET',
  });
}

// 获取厨房唯一代码
export function designCode() {
  return request({
    url: '/designCode/get',
    method: 'GET',
  });
}

// 根据code获取MCC详情报价页面
export function getofferDetailList(designCode, zipCode) {
  return request({
    url: `/template/get/${designCode}?zipcode=${zipCode}`,
    method: 'GET',
  });
}

export function uploadImg(data) {
  return request({
    url: '/component/uploadBase64',
    method: 'POST',
    data: {
      uploadFile: data,
    },
  });
}

// 获取客户留资料并返回保存的二维码图片
export function getleadsInfoImg(data) {
  return request({
    url: '/pay/leadsInfo/submit',
    method: 'POST',
    data,
  });
}

// 取消留资二维码  保存方案二维码生成
export function getResetImg(data) {
  return request({
    url: `/pay/qr/save/get/${data}`,
    method: 'GET',
  });
}

// 保存template模版,获取厨房唯一代码
export function getdesignCode(data) {
  return request({
    url: '/template/save',
    method: 'POST',
    data,
  });
}
// 获取vpsId
export function getVpsId(data) {
  return request({
    url: '/pay/vps/submit',
    method: 'POST',
    data: {
      ...data,
    },
  });
}

export function getStoreByZipCode(zipCode = '') {
  return request({
    url: '/store/storeByZipCode',
    method: 'POST',
    data: {
      zipCode,
    },
  });
}
